// components/ui/Input.jsx
import React from 'react';
import { TextField, Box } from '@mui/material';

export const Input = ({ label, variant = 'outlined', ...props }) => {
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TextField
        label={label}
        variant={variant}
        fullWidth
        {...props}
        sx={{
          '& .MuiOutlinedInput-root': {
            color: 'white',
            '& fieldset': {
              borderColor: 'rgba(139, 0, 0, 0.3)',
              borderRadius: 2,
            },
            '&:hover fieldset': {
              borderColor: 'rgba(139, 0, 0, 0.5)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ff4d4d',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'rgba(255, 255, 255, 0.7)',
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#ff4d4d',
          },
          ...props.sx,
        }}
      />
    </Box>
  );
};